/**
 * @generated SignedSource<<f69210ee3c8221a89494387e1c5ba47a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GetHostedInvoiceUrlInput = {
  clientMutationId?: string | null | undefined;
};
export type ProUpgradeCardGetHostedInvoiceUrlMutation$variables = {
  input: GetHostedInvoiceUrlInput;
};
export type ProUpgradeCardGetHostedInvoiceUrlMutation$data = {
  readonly getHostedInvoiceUrl: {
    readonly url: string;
  } | null | undefined;
};
export type ProUpgradeCardGetHostedInvoiceUrlMutation = {
  response: ProUpgradeCardGetHostedInvoiceUrlMutation$data;
  variables: ProUpgradeCardGetHostedInvoiceUrlMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GetHostedInvoiceUrlPayload",
    "kind": "LinkedField",
    "name": "getHostedInvoiceUrl",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProUpgradeCardGetHostedInvoiceUrlMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProUpgradeCardGetHostedInvoiceUrlMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fc1f0cc1ab62681ed11968fa5cfbd73e",
    "id": null,
    "metadata": {},
    "name": "ProUpgradeCardGetHostedInvoiceUrlMutation",
    "operationKind": "mutation",
    "text": "mutation ProUpgradeCardGetHostedInvoiceUrlMutation(\n  $input: GetHostedInvoiceUrlInput!\n) {\n  getHostedInvoiceUrl(input: $input) {\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "95c98689440c348dd0c9421a5b69a7d2";

export default node;
